import { Controller } from '@hotwired/stimulus';
import { getComponent } from '@symfony/ux-live-component';

export default class extends Controller {
    async initialize () {
        this.component = await getComponent(this.element);

        const $$allParticipantsForms = this.element.querySelectorAll('[data-participant-forms="root"]');
        let $participantsElements = this.element.querySelectorAll('[data-participant-id]');

        $$allParticipantsForms.forEach($participantsForm => {
            const $selfCheckInCheckbox = $participantsForm.querySelector('[data-participant-self-checkin]');

            if ($selfCheckInCheckbox) {
                const userGender = $selfCheckInCheckbox.dataset.checkinGender;
                const userFirstname = $selfCheckInCheckbox.dataset.checkinFirstname;
                const userLastname = $selfCheckInCheckbox.dataset.checkinLastname;
                const userEmail = $selfCheckInCheckbox.dataset.checkinEmail;

                $selfCheckInCheckbox.onchange = () => {
                    changeFormfieldValues();
                };

                // disable all inputs and buttons if self checkin is true
                const lockFields = (firstname, lastname, email, gender, removeBtn) => {
                    if ($selfCheckInCheckbox.checked) {
                        firstname.parentElement.parentElement.classList.add('is--disabled');
                        lastname.parentElement.parentElement.classList.add('is--disabled');
                        email.parentElement.parentElement.classList.add('is--disabled');
                        removeBtn.classList.add('is--disabled');

                        if (userGender !== '') {
                            gender.forEach(gender => {
                                gender.parentElement.parentElement.classList.add('is--disabled');
                            });
                        }
                    } else {
                        firstname.parentElement.parentElement.classList.remove('is--disabled');
                        lastname.parentElement.parentElement.classList.remove('is--disabled');
                        email.parentElement.parentElement.classList.remove('is--disabled');
                        removeBtn.classList.remove('is--disabled');

                        gender.forEach(gender => {
                            gender.parentElement.parentElement.classList.remove('is--disabled');
                        });
                    }
                };

                // initial Check if SelfCheckin is True
                const initCallOnSelfCheckin = () => {
                    if ($selfCheckInCheckbox.checked === true) {
                        const $userForm = $participantsForm.querySelector(`[data-participant-id="${getFieldsetId(userFirstname, userLastname, userEmail)}"]`);
                        if ($userForm) {
                            const $firstnameField = $userForm.querySelector('[data-field-firstname]');
                            const $lastnameField = $userForm.querySelector('[data-field-lastname]');
                            const $emailField = $userForm.querySelector('[data-field-email]');
                            const $genderFields = $userForm.querySelectorAll('[data-field-gender]');
                            const $removeBtn = $userForm.querySelector('[data-remove-button]');
                            lockFields($firstnameField, $lastnameField, $emailField, $genderFields, $removeBtn);
                        }
                    }
                };

                // handle change events in the form
                const changeFormfieldValues = () => {
                    const changeFieldEvent = new CustomEvent('change', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            $context: document
                        }
                    });

                    if ($selfCheckInCheckbox.checked === true) {
                        const $firstEmptyForm = $participantsForm.querySelector(`[data-participant-id="${getFieldsetId('', '', '')}"]`);
                        if ($firstEmptyForm) {
                            const $firstnameField = $firstEmptyForm.querySelector('[data-field-firstname]');
                            const $lastnameField = $firstEmptyForm.querySelector('[data-field-lastname]');
                            const $emailField = $firstEmptyForm.querySelector('[data-field-email]');
                            const $genderFields = $firstEmptyForm.querySelectorAll('[data-field-gender]');
                            const $removeBtn = $firstEmptyForm.querySelector('[data-remove-button]');

                            $firstnameField.value = userFirstname;
                            $lastnameField.value = userLastname;
                            $emailField.value = userEmail;
                            $firstnameField.setAttribute('value', userFirstname);
                            $lastnameField.setAttribute('value', userLastname);
                            $emailField.setAttribute('value', userEmail);

                            $genderFields.forEach(gender => {
                                if (userGender === gender.value) {
                                    gender.checked = true;
                                    gender.dispatchEvent(changeFieldEvent);
                                }
                            });

                            $firstnameField.dispatchEvent(changeFieldEvent);
                            $lastnameField.dispatchEvent(changeFieldEvent);
                            $emailField.dispatchEvent(changeFieldEvent);
                            lockFields($firstnameField, $lastnameField, $emailField, $genderFields, $removeBtn);
                        } else {
                            $selfCheckInCheckbox.checked = false;
                        }
                    } else {
                        const $userForm = $participantsForm.querySelector(`[data-participant-id="${getFieldsetId(userFirstname, userLastname, userEmail)}"]`);
                        if ($userForm) {
                            const $firstnameField = $userForm.querySelector('[data-field-firstname]');
                            const $lastnameField = $userForm.querySelector('[data-field-lastname]');
                            const $emailField = $userForm.querySelector('[data-field-email]');
                            const $genderFields = $userForm.querySelectorAll('[data-field-gender]');
                            const $removeBtn = $userForm.querySelector('[data-remove-button]');

                            $firstnameField.value = '';
                            $lastnameField.value = '';
                            $emailField.value = '';
                            $firstnameField.removeAttribute('value', '');
                            $lastnameField.removeAttribute('value', '');
                            $emailField.removeAttribute('value', '');

                            $genderFields.forEach(gender => {
                                if (userGender === gender.value) {
                                    gender.checked = false;
                                    gender.dispatchEvent(changeFieldEvent);
                                }
                            });

                            $firstnameField.dispatchEvent(changeFieldEvent);
                            $lastnameField.dispatchEvent(changeFieldEvent);
                            $emailField.dispatchEvent(changeFieldEvent);
                            lockFields($firstnameField, $lastnameField, $emailField, $genderFields, $removeBtn);
                        }
                    }
                };

                // get fieldset id depends on input values
                const getFieldsetId = (firstnameValue, lastnameValue, emailValue) => {
                    for (const participant of $participantsElements) {
                        const formID = participant.dataset.participantId;
                        const $firstnameField = participant.querySelector('[data-field-firstname]');
                        const $lastnameField = participant.querySelector('[data-field-lastname]');
                        const $emailField = participant.querySelector('[data-field-email]');

                        if ($firstnameField.value === firstnameValue && $lastnameField.value === lastnameValue && $emailField.value === emailValue) {
                            return formID;
                        }
                    }
                    return null;
                };

                // init call
                initCallOnSelfCheckin();
            }
        });

        const checkFormFieldsHasError = () => {
            const $firstFieldWithError = this.element.querySelector('.has--error');

            if ($firstFieldWithError) {
                const $inputField = $firstFieldWithError.querySelector('input');

                if ($inputField) {
                    $inputField.focus();
                    $inputField.scrollTo();
                }
            }
        };

        const updateCartCount = () => {
            const $cartItemsCount = this.element.querySelector('[data-cart-count]');
            const cartCount = $cartItemsCount ? parseInt($cartItemsCount.dataset.cartCount, 10) : 0;
            const $shopbasketIndicator = document.querySelector('[data-basket]');

            if (cartCount === 0) {
                $shopbasketIndicator.classList.remove('is--active');
            } else {
                $shopbasketIndicator.classList.add('is--active');
            }

            $shopbasketIndicator.textContent = cartCount;
        };

        this.component.on('render:finished', (component) => {
            // re assign usable forms for the iteration
            $participantsElements = this.element.querySelectorAll('[data-participant-id]');

            // update cart count if it changes
            updateCartCount();

            // check if any input fields has errors inside our component
            checkFormFieldsHasError();
        });
    }
}
